import { render, staticRenderFns } from "./FileDownloadWidget.vue?vue&type=template&id=cd234404&scoped=true"
import script from "./FileDownloadWidget.vue?vue&type=script&lang=js"
export * from "./FileDownloadWidget.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadWidget.vue?vue&type=style&index=0&id=cd234404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd234404",
  null
  
)

export default component.exports